module.exports = __webpack_public_path__ + "img/problem.6704c2ca.png";